$(function () {
  // ===== Index page: filter dropdown =====
  $('.purchase-aggregation-filter-card .select2-default-all').select2({
    width: '100%',
    theme: 'bootstrap',
    allowClear: false,
    language: { noResults: function () { return '見つかりません。'; } },
  });

  initPurchaseAggregationTaxToggle();
  $(document).on('change', '#purchase-aggregation-tax-toggle', function () {
    applyPurchaseAggregationTax(this.checked);
  });

  // ===== Show page =====
  if ($('.purchase-aggregation-show-page').length === 0) return;

  // ---- show page filters (部署 / 請求確認状態) ----
  var $departmentFilter = $('#pa-department-filter');
  var $billingFilter = $('#pa-billing-status-filter');

  $departmentFilter.select2({
    width: '140px',
    theme: 'bootstrap',
    allowClear: false,
    minimumResultsForSearch: Infinity,
    language: { noResults: function () { return '見つかりません。'; } },
  });

  $billingFilter.select2({
    width: '140px',
    theme: 'bootstrap',
    allowClear: false,
    minimumResultsForSearch: Infinity,
    language: { noResults: function () { return '見つかりません。'; } },
  });

  function reloadShowWithFilters() {
    var baseUrl = $billingFilter.data('url') || $departmentFilter.data('url');
    if (!baseUrl) return;

    var params = [];
    var departmentId = $departmentFilter.val();
    var billingStatus = $billingFilter.val();
    if (departmentId) params.push('detail_department_id=' + encodeURIComponent(departmentId));
    if (billingStatus) params.push('billing_status=' + encodeURIComponent(billingStatus));

    var sep = baseUrl.indexOf('?') >= 0 ? '&' : '?';
    window.location.href = params.length ? (baseUrl + sep + params.join('&')) : baseUrl;
  }

  $departmentFilter.on('change', reloadShowWithFilters);
  $billingFilter.on('change', reloadShowWithFilters);

  // ---- helpers ----
  function formatNumber(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Interactive checkboxes only (exclude confirmed/disabled = checked by logic)
  function interactiveChecks() {
    return $('.pa-item-check:not(:disabled)');
  }

  // 全選択 / 選択解除 enable state
  // - Ignore checkboxes checked by server logic on page load (data-initial-checked)
  // - Only count checks made by user JS after page load
  function updateSelectButtons() {
    var $checks = interactiveChecks();
    var hasUnchecked = $checks.filter(':not(:checked)').length > 0;
    var hasUserChecked = $checks.filter(function () {
      return $(this).is(':checked') && !$(this).data('initial-checked');
    }).length > 0;

    $('#pa-select-all').prop('disabled', $checks.length === 0 || !hasUnchecked);
    $('#pa-deselect-all').prop('disabled', !hasUserChecked);
  }

  function updateSummary() {
    var count           = 0;
    var amount          = 0;
    var paymentCount    = 0;
    var paymentAmount   = 0;
    var uncheckedCount  = 0;
    var uncheckedAmount = 0;

    // 選択件数/選択金額: ALL visually-checked (is_reconciliation_checked || confirmed)
    // 支払対象金額/チェック件数: only non-confirmed (not yet payment-created)
    // 未チェック件数/金額: non-confirmed items that are not checked
    $('.pa-item-check').each(function () {
      var $row      = $(this).closest('.pa-item-row');
      var rowAmount = parseFloat($row.attr('data-amount') || 0);
      var rowAmountWithTax = parseFloat($row.attr('data-amount-with-tax') || 0);
      var confirmed = $row.attr('data-confirmed') === 'true';
      var checked   = $(this).is(':checked');

      if (checked) {
        count++;
        amount += rowAmountWithTax;
        if (!confirmed) {
          paymentCount++;
          paymentAmount += rowAmount;
        }
      } else if (!confirmed) {
        uncheckedCount++;
        uncheckedAmount += rowAmountWithTax;
      }
    });

    $('#pa-selected-count').text(count);
    $('#pa-selected-amount').text(formatNumber(amount));
    $('#pa-unchecked-count').text(uncheckedCount);
    $('#pa-unchecked-amount').text(formatNumber(uncheckedAmount));
    $('#pa-payment-count-display').text(paymentCount);
    $('#pa-payment-amount-display').text(formatNumber(paymentAmount));

    var hasSelection = paymentCount > 0;
    var $dateField = $('#pa-payment-date');
    $dateField.prop('disabled', !hasSelection);
    $dateField.toggleClass('pa-date-disabled', !hasSelection);
    if (!hasSelection) {
      $dateField.val('');
      var drp = $dateField.data('daterangepicker');
      if (drp) drp.hide();
    }
    checkSubmitEnabled(paymentCount, paymentAmount);
    updateSelectButtons();
  }

  // Enable 支払情報作成する only when:
  // - 支払日 is filled
  // - チェック件数 > 0
  // - 支払対象金額 > 0
  function checkSubmitEnabled(paymentCount, paymentAmount) {
    if (typeof paymentCount === 'undefined') {
      paymentCount = parseInt($('#pa-payment-count-display').text() || '0', 10) || 0;
    }
    if (typeof paymentAmount === 'undefined') {
      paymentAmount = parseFloat(($('#pa-payment-amount-display').text() || '0').replace(/,/g, '')) || 0;
    }
    var hasDate = $('#pa-payment-date').val().trim().length > 0;
    var canSubmit = hasDate && paymentCount > 0 && paymentAmount > 0;
    $('#pa-submit-btn').prop('disabled', !canSubmit);
  }

  // ---- checkbox interactions (UI only, no API call) ----
  $(document).on('change', '.pa-item-check:not(:disabled)', function () {
    var $row = $(this).closest('.pa-item-row');
    if ($(this).is(':checked')) { $row.addClass('pa-row-selected'); }
    else                        { $row.removeClass('pa-row-selected'); }
    updateSummary();
  });

  $('#pa-select-all').on('click', function () {
    if ($(this).prop('disabled')) return;
    interactiveChecks().prop('checked', true)
      .closest('.pa-item-row').addClass('pa-row-selected');
    updateSummary();
  });

  $('#pa-deselect-all').on('click', function () {
    if ($(this).prop('disabled')) return;
    // Only clear checkboxes the user checked after page load (keep logic-checked)
    interactiveChecks().filter(function () {
      return $(this).is(':checked') && !$(this).data('initial-checked');
    }).prop('checked', false)
      .closest('.pa-item-row').removeClass('pa-row-selected');
    updateSummary();
  });

  // ---- payment date picker (daterangepicker singledate) ----
  var $paymentDate = $('#pa-payment-date');
  $paymentDate.daterangepicker({
    locale: ja_date_locale,
    singleDatePicker: true,
    autoUpdateInput: false,
    autoApply: true,
    showDropdowns: true,
  }).on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('YYYY/MM/DD'));
    checkSubmitEnabled();
  }).on('cancel.daterangepicker', function () {
    $(this).val('');
    checkSubmitEnabled();
  }).on('show.daterangepicker', function (ev, picker) {
    if ($(this).prop('disabled')) {
      picker.hide();
    }
  });

  // ---- print: handled by link_to in show.html.erb (navigates to export_detail_pdf) ----

  // ---- init on page load ----
  // Remember checkboxes checked by server logic (is_reconciliation_checked / confirmed)
  // so 全選択 / 選択解除 only react to user checks after load
  interactiveChecks().each(function () {
    $(this).data('initial-checked', $(this).is(':checked'));
  });

  // Apply selected style to rows already checked from DB
  $('.pa-item-check:checked').each(function () {
    var $row = $(this).closest('.pa-item-row');
    if ($row.attr('data-confirmed') !== 'true') {
      $row.addClass('pa-row-selected');
    }
  });

  // Sync 支払日 enable/disable with non-confirmed checked count
  // Also sets 全選択 / 選択解除 initial disabled state
  updateSummary();
});

function formatPaAmount(n) {
  return '¥' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function applyPurchaseAggregationTax(enabled) {
  var taxRate = 1.1;
  document.querySelectorAll('.js-pa-amount').forEach(function (el) {
    var raw = parseFloat(el.dataset.amount) || 0;
    var value = enabled ? raw * taxRate : raw;
    el.textContent = formatPaAmount(value);
  });

  var $print = $('#purchase-aggregation-print');
  if ($print.length) {
    var url = new URL($print.attr('href'), window.location.origin);
    url.searchParams.set('include_tax', enabled ? '1' : '0');
    $print.attr('href', url.pathname + url.search);
  }

  try {
    localStorage.setItem('purchase-aggregation-tax-included', enabled ? '1' : '0');
  } catch (e) {}
}

function initPurchaseAggregationTaxToggle() {
  var toggle = document.getElementById('purchase-aggregation-tax-toggle');
  if (!toggle) return;

  var saved = false;
  try {
    saved = localStorage.getItem('purchase-aggregation-tax-included') === '1';
  } catch (e) {}

  toggle.checked = saved;
  applyPurchaseAggregationTax(saved);
}
